<template>
    <div>
        <div class="w-full h-full">
            <MapView ref="mapEditor" :search="false" :info="false" :oper="false" :list="false" :drawData="drawInfo" :markers="pointList" />
        </div>
        <div class="detail-container">
            <div class="font-com" style="letter-spacing: 0.8px;">
                {{ info.name || '地点名称' }}
                <label>[{{ typeFormat }}]</label>
                <label v-if="info.vrinfo" class="cursor-pointer margin-left-sm" @click="checkVRView">[ 全景 ]</label>
            </div>
            <div class="margin-top-md border-radius-sm overflow-hidden" v-if="info.pictureList && info.pictureList.length">
                <el-carousel trigger="click" height="220px" arrow="always">
                    <el-carousel-item v-for="(item, index) in info.pictureList" :key="index">
                        <el-image :src="item" class="width-all height-all" fit="cover" :preview-src-list="info.pictureList" />
                    </el-carousel-item>
                </el-carousel>
            </div>

            <div class="margin-tb-md" style="text-indent: 2em;line-height: 25px;" v-if="info.remark">
                {{ info.remark || '-' }}
            </div>

            <div class="flex flex-warp margin-bottom-md tag-box" v-if="info.tags && info.tags.length">
                <div class="tag-card" v-for="(tItem, tIndex) in info.tags" :key="tIndex">{{ tItem }}</div>
            </div>

            <div class="margin-bottom-sm">热力度： 
                <span v-for="item in info.hot" :key="`h1${item}`">★</span>
                <span v-for="item in (5 - info.hot)" :key="`h2${item}`">☆</span>
            </div>

            <div class="margin-bottom-sm">推荐度： 
                <span v-for="item in info.rate" :key="`r1${item}`">★</span>
                <span v-for="item in (5 - info.rate)" :key="`r2${item}`">☆</span>
            </div>

            <div class="margin-bottom-sm" v-if="info.address">具体位置：{{ info.address || '-' }}</div>
             
            <div class="margin-bottom-sm" v-if="info.localDate">打卡时间：{{ info.localDate }}</div>

            <div class="margin-bottom-sm flex flex-warp margin-bottom-sm tag-box" v-if="info.foodList && info.foodList.length">
                <div>购买推荐：</div>
                <div class="tag-card" v-for="(fItem, fIndex) in info.foodList" :key="fIndex">{{ fItem }}</div>
            </div>

            <div class="margin-bottom-sm" style="line-height: 25px;" v-if="info.evaluation">
                小编评价：{{ info.evaluation || '-' }}
            </div>
        </div>
    </div>
</template>
<script>
	import MapView from '@/components/MapView.vue';
	import { getJson } from "@/utils/axios.js"
    export default{
		components: { MapView },
        data(){
            return{
                drawInfo: [],
				pointList: [],
				pointTypeOptions: [],
                info: {
                    hot: 5,
                    rate: 5
                },
                id: this.$route.query.id
            }
        },
        computed: {
			typeFormat(){
				const itemIndex = this.pointTypeOptions.findIndex(item => item.dicValue === this.info.type )
                if(itemIndex > -1){
                    return this.pointTypeOptions[itemIndex].dicLabel
                }else{
                    return ''
                }
			},
		},
        methods: {
            checkVRView(){
                window.open(`${window.location.origin}/view?id=${this.info.id}`)
            },
            getDicOptions(){
				getJson('/dicContent/list', { dicKey: 'walk_point_type' }, (res) => {
					this.pointTypeOptions = res.data || []
				})
			},
			getDetail(){
				getJson('/point/detail', {
					id: this.id,
				}, (res) => {
					const { data } = res
                    this.info = data || {}
                    this.info.pictureList = this.info.picture ? this.info.picture.split(',') : []
                    this.info.tags = this.info.tag.split(',')
                    this.info.foodList = this.info.foods ? this.info.foods.split(',') : []
				})
			},
        },
        created(){
            this.getDicOptions()
            this.getDetail()
        }
    }
</script>
<style scoped lang="scss">
    :deep(.el-skeleton__paragraph){
        margin-top: 6px;
    }
    .detail-container{
		position: absolute;
        left: 0;right: 0;top: 0;
        z-index: 9249;
        height: 100vh;
        width: 100vw;
        overflow-x: hidden;
		z-index: 924;
		background-color: rgba(15, 88, 181, 0.3);
		backdrop-filter: blur(8px);
		border-radius: 5px;
		transition: 300ms;
		color: #FFF;
		text-align: left;
		font-size: 16px;
        padding: 15px;
        box-sizing: border-box;
        overflow-y: auto;
	}
    .tag-box{
        gap: 10px;
    }
    .tag-card{
        border: 1px solid #FFF;
        border-radius: 5px;
        padding: 0 10px;
    }
</style>